import createCrudVuexModule from "@/store/crud";
export const organizationQuestionSetAndSurvey = createCrudVuexModule({
  state: {
    selectedTab: "questionset",
  },
  getters: {
    selectedTab: (state) => state.selectedTab,
  },
  mutations: {
    selectedTab: (state, value) => (state.selectedTab = value),
  },
  actions: {},
});
